import AuthForm, { AuthFormProps } from 'common/components/AuthForm';
import Modal from 'common/components/Modal';
import Portal from 'common/components/Portal';
import React from 'react';

interface Props extends AuthFormProps {
    isVisible?: boolean;
    isDismissable?: boolean;
    onDismiss?: () => void;
}

const AuthModal: React.SFC<Props> = props => {
    const {
        isVisible,
        isDismissable = true,
        onDismiss,
        showHeaderDivider,
        modalComponent,
        ...childProps
    } = props;
    const ModalToRender = modalComponent ? modalComponent : Modal;

    return (
        <Portal>
            <ModalToRender onDismiss={isDismissable ? onDismiss : undefined} isVisible={isVisible}>
                <AuthForm showHeaderDivider={showHeaderDivider} {...childProps} />
            </ModalToRender>
        </Portal>
    );
};

export default AuthModal;
